<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <section v-if="customerInfo.id">
      <h1>{{ human_readable_name(customerInfo) }}</h1>
      <div v-if="customerInfo.statutar">statutární orgán: {{ customerInfo.statutar }}</div>

      <div>

        <div class="row">
          <div class="col-md-2">
            Klientské číslo
          </div>
          <div class="col-md-10">
            {{ customerInfo.id }}
            <br>
            <span id="grey-note">slouží zároveň jako variabilní symbol pro platby</span>
          </div>
        </div>

        <div class="row" v-if="customerInfo.ten">
          <div class="col-md-2">
            IČO
          </div>
          <div class="col-md-10">
            {{ customerInfo.ten }}
          </div>
        </div>

        <div class="row" v-if="customerInfo.regon">
          <div class="col-md-2">
            DIČ
          </div>
          <div class="col-md-10">
            {{ customerInfo.regon }}
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            Telefon
          </div>
          <div class="col-md-10">
            <div v-for="pn in customerInfo.phoneNumbers" :key="pn.phone">
              {{ pn.phone }}
              <span v-if="pn.typ_sml == 0 || pn.typ_tech == 0">
                <span v-if="pn.typ_sml">✆ smluvní</span>
                <span v-if="pn.typ_tech">✆ technický</span>
              </span>
              <span v-if="pn.name"> ({{pn.name}})</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            E-mail
          </div>
          <div class="col-md-10">
            <div v-for="e in customerInfo.emailAddresses" :key="e.email">
              {{ e.email }}
              <span v-if="e.typ_sml == 0 || e.typ_f == 0 || e.typ_tech == 0 || e.typ_sam == 0">
                <span v-if="e.typ_sml">📧 smluvní</span>
                <span v-if="e.typ_f">📧 fakturační</span>
                <span v-if="e.typ_tech">📧 technický</span>
                <span v-if="e.typ_sam">📧 přístup do samoobsluhy</span>
              </span>
              <span v-if="e.note"> ({{e.note}})</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <span v-if="customerInfo.type == 1">Sídlo</span>
            <span v-else>Trvalé bydliště</span>
          </div>
          <div class="col-md-10">
            <div>{{ customerInfo.address }}</div>
            <div>{{ customerInfo.zip }} {{ customerInfo.city }}</div>
            <div>{{ country_name(customerInfo.countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.post_address">
          <div class="col-md-2">
            Doručovací adresa
          </div>
          <div class="col-md-10">
            <div v-if="customerInfo.post_name">{{ customerInfo.post_name }}</div>
            <div>{{ customerInfo.post_address }}</div>
            <div>{{ customerInfo.post_zip }} {{ customerInfo.post_city }}</div>
            <div>{{ country_name(customerInfo.post_countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.inv_address">
          <div class="col-md-2">
            Fakturační adresa
          </div>
          <div class="col-md-10">
            <div v-if="customerInfo.inv_name">{{ customerInfo.inv_name }}</div>
            <div>{{ customerInfo.inv_address }}</div>
            <div>{{ customerInfo.inv_zip }} {{ customerInfo.inv_city }}</div>
            <div>{{ country_name(customerInfo.inv_countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.bank1">
          <div class="col-md-2">
            Číslo účtu
          </div>
          <div class="col-md-10">
            {{ customerInfo.bank1 }}
            <span v-if="customerInfo.bank2"> / {{ customerInfo.bank2 }}</span>
          </div>
        </div>

        <div class="row" v-if="customerInfo.oku_list && customerInfo.oku_list.length > 0" >
          <div class="col-md-2">
            Ověřovací kód účastníka
          </div>
          <div class="col-md-10">
            <div v-if="!showFullOKU" @click="OKUclicked()">
              <span class="monospace">{{customerInfo.oku_list[0].oku.substr(0,3)}}</span> ... <a href="#">zobrazit</a>
            </div>
            <div v-else>
              <div v-for="oku in customerInfo.oku_list" :key="oku.oku">
                <span class="monospace">{{oku.oku}}</span>
                <span v-if="customerInfo.oku_list.length > 1">pro {{oku.service_name}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </section>
</template>

<script>
import CustomerResource from '../backend-resources/customer-resource'

export default {
  data () {
    return {
      customerInfo: {},
      displayError: null,
      isLoading: false,
      showFullOKU: false
    }
  },
  created: function () {
    this.isLoading = true
    CustomerResource.get().then((response) => {
      this.customerInfo = response.data
      this.displayError = null
      this.isLoading = false
    }).catch((error) => {
      this.displayError = error.response.status + ' ' + error.response.statusText
      this.isLoading = false
    })
  },
  methods: {
    human_readable_name: function (ci) {
      return ci.degree1 + ' ' + ci.name + ' ' + ci.lastname + ' ' + ci.degree2 +
        ((ci.name || ci.lastname) && ci.bussinesname ? ' - ' : '') +
        (ci.bussinesname ? ci.bussinesname : '')
    },
    country_name: function (countryid) {
      let c = this.customerInfo.countries
      if (!c) return ''
      return c[countryid]
    },
    OKUclicked: function () {
      this.showFullOKU = true
      CustomerResource.recordOKUdisplay()
    }
  }
}

</script>
<style>
h1 {
  font-size: 1.5em;
}
.row {
  margin-top: 1em;
  margin-bottom: 1em;
}
#grey-note {
  color: grey;
}
.monospace {
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// PersonalDetails.vue?93f89062